import { Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from "@mui/material";
import Header from "../../../Layout/Header";
import { useEffect, useState } from "react";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import { tokens } from "../../../theme/theme";
import useGetSONumberListForReelTransfer from "../../../hooks/useGetSONumberListForReelTransfer";

const TransferReelListDetail = ({ callback }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState();

    const transferToByHook = useGetSONumberListForReelTransfer(0);

    // Call only once when component is mounted
    useEffect(() => {
        transferToByHook.fetchTransferedReelList();
    }, []); // <- empty array = only run on mount
    return (
        <>
            <Header title="List of Transfered Reel " subtitle="" callback={callback} />
            <Divider />
            <CustomTableContainer colors={colors}>
                <TableContainer>
                    {loading ? (
                        <SkeletonTableLoader rows={5} columns={6} />
                    ) : (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>REEL NUMBER</TableCell>
                                    <TableCell>REEL SIZE</TableCell>
                                    <TableCell>QUALITY</TableCell>
                                    <TableCell>GSM</TableCell>
                                    <TableCell>TRANSFERED SO NUMBER</TableCell>
                                    <TableCell>TRANSFERED SIZE</TableCell>
                                    <TableCell>ACTUAL SO NUMBER</TableCell>
                                    <TableCell>ACTUAL SIZE</TableCell>
                                    <TableCell>QUANTITY</TableCell>
                                    <TableCell>TRANSFERED DATE</TableCell>
                                    <TableCell>STATUS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {transferToByHook.transferReelList.map((s) => (
                                    <TableRow key={s.id}>
                                        <TableCell>{s.id}</TableCell>
                                        <TableCell>{s.cr_number}</TableCell>
                                        <TableCell>{s.master_reel}</TableCell>

                                        <TableCell>{s.item_code}</TableCell>
                                        <TableCell>{s.gsm}</TableCell>
                                        <TableCell>{s.transfered_so}</TableCell>
                                        <TableCell>{s.transfered_size}</TableCell>
                                        <TableCell>{s.actual_so}</TableCell>
                                        <TableCell>{s.actual_size}</TableCell>
                                        <TableCell>{s.quantity}</TableCell>
                                        <TableCell>{s.created_date}</TableCell>                                        
                                        <TableCell>{s.status}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </TableContainer>
            </CustomTableContainer>
        </>
    );
}
export default TransferReelListDetail;